import { render, staticRenderFns } from "./DashboardWelcomeCard.vue?vue&type=template&id=1390fa14&scoped=true&"
import script from "./DashboardWelcomeCard.vue?vue&type=script&lang=js&"
export * from "./DashboardWelcomeCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWelcomeCard.vue?vue&type=style&index=0&id=1390fa14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1390fa14",
  null
  
)

export default component.exports